import { Box } from "@mui/material";

import styled from "styled-components";

export const UrlList = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px 24px;
`;

export const UrlRow = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const UrlLabel = styled(Box)`
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #86868b;
    font-family: "Nunito", sans-serif;
`;

export const UrlValueBox = styled(Box)`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: #f7f7f8;
    border: 1px solid #e5e5ea;
    border-radius: 10px;
    padding: 12px 14px;
`;

export const UrlValueText = styled(Box)`
    flex: 1;
    min-width: 0;
    font-size: 13px;
    font-family: "Nunito", sans-serif;
    color: #1d1d1f;
    word-break: break-all;
    line-height: 1.5;
`;

export const EmptyUrlsState = styled(Box)`
    padding: 40px 24px;
    text-align: center;
    font-family: "Nunito", sans-serif;
    font-size: 14px;
    color: #86868b;
`;
